import styled from 'styled-components'

export const EmptyWrapper = styled.div`
  max-width: 368px;
`
